export const CALCULATED_DIMENSION_TIMESTAMP_TYPE = 'google.protobuf.Timestamp';

export const calculatedDimensionTypeOptions = [
  { title: 'Text', value: 'TYPE_STRING' },
  { title: 'Number', value: 'TYPE_DOUBLE' },
  { title: 'Boolean', value: 'TYPE_BOOL' },
  { title: 'Date', value: CALCULATED_DIMENSION_TIMESTAMP_TYPE },
];

type CalculatedDimensionKind = 'TYPE_STRING' | 'TYPE_DOUBLE' | 'TYPE_BOOL';

export type CalculatedDimensionType =
  { kindWrapper: { kind: CalculatedDimensionKind } } | { typeNameWrapper: { name: typeof CALCULATED_DIMENSION_TIMESTAMP_TYPE } };

export type CalculatedDimensionTypeValue = CalculatedDimensionKind | typeof CALCULATED_DIMENSION_TIMESTAMP_TYPE;

export type CalculatedDimensionContext = {
  name: string;
  builtIn: boolean;
};

export type CalculatedDimension = {
  id?: string;
  builtin: boolean;
  systemName: string;
  displayName: string;
  description?: string;
  expression?: string;
  timeExpression?: string;
  type?: CalculatedDimensionType;
  context?: CalculatedDimensionContext[];
  hidden: boolean;
  createdByUserId?: string;
  updatedByUserId?: string;
};

export type CustomCalculatedDimension = Pick<
  CalculatedDimension,
  'displayName' | 'description' | 'expression' | 'timeExpression' | 'context' | 'hidden'
> & {
  type: CalculatedDimensionType;
  systemName?: string;
};

export enum MODES {
  EDIT_MODE = 'EDIT',
  CREATE_MODE = 'CREATE',
  VIEW_MODE = 'VIEW',
}
